<template>
  <validation-provider :name="texto" :rules="{ required: requerida }" v-slot="validationContext">
    <b-form-group label-cols-md="4" :label="texto + ':'" :label-for="realId">
      <b-form-checkbox-group :id="realId" v-model="respuesta" :state="getValidationState(validationContext)" stacked>
        <b-form-checkbox v-for="opcion in opciones" :key="opcion.id" :name="realId" :value="opcion.id">{{ opcion.label }}</b-form-checkbox>
      </b-form-checkbox-group>
      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
      <b-form-text v-if="ayuda">{{ ayuda }}</b-form-text>
    </b-form-group>
  </validation-provider>
</template>

<script lang="ts">
import { nanoid } from 'nanoid'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

@Component
export default class TipoRadio extends Vue {
  @Prop() id: string
  @Prop() texto: string
  @Prop({ default: '' }) ayuda: string
  @Prop({ default: true }) requerida: Boolean
  @Prop() placeholder: string
  @Prop() value: Array<any>
  @Prop() meta: any

  get realId(): string {
    return this.id || 'check-' + nanoid()
  }

  public respuesta: Array<any> = []
  public opciones: Array<any> = []
  public buscar: any = ''

  filtrarOpciones(opciones: Array<any>): Array<any> {
    if (this.meta['buscar_id']) {
      let self = this
      return opciones.filter(function (item) {
        let buscar = self.buscar
        if (!Array.isArray(buscar))
          buscar = [buscar]
        return buscar.includes(item['search'])
      })
    } else {
      return opciones
    }
  }

  getValidationState({ validated, dirty = null, valid = null, passed = null }) {
    return validated || valid ? valid : null
  }

  @Watch('respuesta')
  onRespuestaChange(value) {
    this.$emit('input', value)
    //this.$parent.$emit('respuesta-' + this.id, value)
  }

  @Watch('value')
  onValueChange(value) {
    this.respuesta = value
    //this.$parent.$emit('respuesta-' + this.id, value)
  }

  created() {
    this.respuesta = this.value || []
    const lines = this.meta.opciones.trim().split(/\r\n|\n/)
    // Reading line by line
    this.opciones = lines.map(function (line) {
      let [id, label, search] = line.split(':')
      return { id, label, search }
    })
    if (this.meta['buscar_id']) {
      let self = this
      this.$parent.$on('respuesta-' + this.meta['buscar_id'], function (respuesta) {
        self.buscar = respuesta
        self.$forceUpdate()
      })
    }
  }
}
</script>